import { CollectionReference, doc, DocumentReference, Firestore } from '@angular/fire/firestore';
import { Organization } from '../../models/organization/organization.model';
import { ORGANIZATION_USERS_COLLECTION, ORGANIZATIONS_COLLECTION } from '../paths/organization.path';
import { getCollectionRef, getRefFromPath } from '../utils/firestore.refs';
import { OrganizationUser } from '../../models/organization/organization-user.model';

//
// Organization
//
export function getOrganizationsCol(firestore: Firestore): CollectionReference<Organization> {
  return getCollectionRef<Organization>(firestore, ORGANIZATIONS_COLLECTION);
}

export function getOrganizationRef(firestore: Firestore, organizationId: string): DocumentReference<Organization> {
  const col = getOrganizationsCol(firestore);
  return doc(col, organizationId);
}

export function getOrganizationRefFromPath(firestore: Firestore, path: string): DocumentReference<Organization> {
  return getRefFromPath<Organization>(firestore, path);
}

//
// OrganizationUser
//
export function getOrganizationUsersCol(
  parentRef: DocumentReference<Organization>
): CollectionReference<OrganizationUser> {
  return getCollectionRef<OrganizationUser>(parentRef, ORGANIZATION_USERS_COLLECTION);
}

export function getOrganizationUserRefFromPath(
  firestore: Firestore,
  path: string
): DocumentReference<OrganizationUser> {
  return getRefFromPath<OrganizationUser>(firestore, path);
}
